/**
 * @module builder
 */
import type { MoveableItem, QuoteItemSection } from '../../index'
import { moveToAddedOptions } from './move-to-added-options'
import { moveToBid } from './move-to-bid'
import { moveToOptions } from './move-to-options'
import { moveToArchived } from './move-to-archived'
import { moveToAdditional } from './move-to-additional'
import { moveToPending } from './move-to-pending'

export function moveTo(item: MoveableItem, section: QuoteItemSection): any {
  if (section === 'bid') {
    return moveToBid(item)
  } else if (section === 'options') {
    return moveToOptions(item)
  } else if (section === 'archived') {
    return moveToArchived(item)
  } else if (section === 'additional') {
    return moveToAdditional(item)
  } else if (section === 'pending') {
    return moveToPending(item)
  } else if (section === 'added-options') {
    return moveToAddedOptions(item)
  } else {
    return item
  }
}
